import {Directive, HostListener, Input} from '@angular/core';
import {NgModel} from '@angular/forms';

@Directive({
  selector: '[ngModel][appOnlyDigits]'
})
export class OnlyDigitsDirective {
  @Input() allowDot: boolean;
  @Input() max: number;

  constructor(private model: NgModel) {}

  @HostListener('keydown', ['$event']) onKeyDown(e: KeyboardEvent) {
    const key = e.key;
    if (this.allowDot && (key === '.' || key === ',')) {
      const target: any = e.target;
      const value = target.value.toString();
      if (!value || value.match(/(\.|\,)/)) {
        e.preventDefault();
      } else {
        return;
      }
    }
    if (
      // Allow: Delete, Backspace, Tab, Escape, Enter
      ['Delete', 'Backspace', 'Tab', 'Escape', 'Enter'].indexOf(key) !== -1 ||
      (key === 'a' && e.ctrlKey === true) || // Allow: Ctrl+A
      (key === 'c' && e.ctrlKey === true) || // Allow: Ctrl+C
      (key === 'v' && e.ctrlKey === true) || // Allow: Ctrl+V
      (key === 'x' && e.ctrlKey === true) || // Allow: Ctrl+X
      (key === 'a' && e.metaKey === true) || // Cmd+A (Mac)
      (key === 'c' && e.metaKey === true) || // Cmd+C (Mac)
      (key === 'v' && e.metaKey === true) || // Cmd+V (Mac)
      (key === 'c' && e.metaKey === true) || // Cmd+X (Mac)
      // Allow: End, Home, Left, Up, Right
      ['End', 'Home', 'ArrowLeft', 'ArrowUp', 'ArrowRight'].indexOf(key) !== -1
    ) {
      return;
    }
    if (e.shiftKey || ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].indexOf(key) === -1) {
      e.preventDefault();
    }
  }

  @HostListener('keyup', ['$event']) onKeyUp(e: KeyboardEvent) {
    const key = e.key;
    let value = this.model.control.value || 0;
    if (this.allowDot && key === ',') {
      this.model.control.setValue(value.toString().replace(',', '.'), {onlySelf: true, emitEvent: true});
      value = this.model.control.value || 0;
    }
    const output = Number(value.toString());
    if (this.allowDot && key !== '.') {
      const check = output.toString().split('.')[1] + '';
      let newValue;
      if (output >= 0) {
        newValue = check !== 'undefined' && check.length > 2 ? (Math.ceil(output * 100) / 100).toFixed(2) : output.toString();
      } else {
        newValue = '';
      }
      if (newValue !== output.toString()) {
        this.model.control.setValue(newValue);
      }
    }
  }

  @HostListener('input', ['$event']) onChange(e: Event) {
    const target: any = e.target;
    const output = Number(target.value.toString());
    if (this.max !== undefined) {
      let newValue;
      if (output !== 0) {
        newValue = output >= this.max ? this.max.toString() : output.toString();
      } else {
        newValue = '';
      }
      if (newValue !== output.toString()) {
        this.model.valueAccessor.writeValue(newValue);
      }
    }
  }
}
